import React from "react";
import { CurrencyDollar, ArrowUp, ArrowDown } from "@phosphor-icons/react";
import { Transaction } from "../types";
import { formatCurrency } from "../utils/calculations";

interface RecentTransactionsProps {
  transactions: Transaction[];
}

const RecentTransactions: React.FC<RecentTransactionsProps> = ({
  transactions,
}) => {
  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Recent Transactions</h3>
        <a href="#" className="text-sm text-primary-500 hover:text-primary-400">
          View all
        </a>
      </div>

      <div className="space-y-4">
        {transactions.length > 0 ? (
          transactions.map((transaction) => (
            <div
              key={transaction.id}
              className="flex items-center justify-between p-3 bg-gray-100 dark:bg-gray-700 rounded-lg">
              <div className="flex items-center space-x-3">
                <div
                  className={`w-10 h-10 rounded-full flex items-center justify-center ${
                    transaction.type === "income"
                      ? "bg-gradient-to-br from-green-400 to-green-600"
                      : "bg-gradient-to-br from-red-400 to-red-600"
                  }`}>
                  {transaction.type === "income" ? (
                    <ArrowUp className="w-5 h-5 text-white" weight="bold" />
                  ) : (
                    <ArrowDown className="w-5 h-5 text-white" weight="bold" />
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-gray-900 dark:text-white font-medium">
                    {transaction.description}
                  </p>
                  <p className="text-sm text-gray-700 dark:text-gray-300">
                    {transaction.category}
                  </p>
                </div>
              </div>
              <div className="text-right">
                <p
                  className={`font-medium ${
                    transaction.type === "income"
                      ? "text-green-500"
                      : "text-red-500"
                  }`}>
                  {transaction.type === "income" ? "+" : "-"}
                  {formatCurrency(transaction.amount)}
                </p>
                <p className="text-xs text-gray-600 dark:text-gray-400">
                  {new Date(transaction.date).toLocaleDateString()}
                </p>
              </div>
            </div>
          ))
        ) : (
          <div className="flex flex-col items-center justify-center py-12 text-gray-500 dark:text-gray-400">
            <CurrencyDollar className="w-16 h-16 mb-4 opacity-50" />
            <p className="text-lg font-medium text-gray-700 dark:text-gray-300">No transactions yet</p>
            <p className="text-sm text-center text-gray-600 dark:text-gray-400">
              Add your first transaction to start tracking your finances
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default RecentTransactions;
